import React, { MouseEvent } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import styled from 'styled-components';
import { FormikProps, useFormikContext } from 'formik';
import { IUser } from 'models/IUser';
import { useTypedSelector } from 'hooks/useTypedSelector';
import './password.scss';

interface PasswordProps {
  formik: FormikProps<Partial<IUser>>;
}

const PasswordInput = styled(TextField)`
  width: calc(100% - 100px);
  border: none;
  & fieldset {
    border: none;
  }
  & .Mui-error::after {
    content: ' ';
    background: #e855e1;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.5;
  }
  & .MuiInputAdornment-positionEnd {
    z-index: 1;
  }
`;

export const Password: React.FC<PasswordProps> = (props) => {
  const { values, setFieldValue }: FormikProps<IUser> = useFormikContext();
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [showPassword, setShowPassword] = React.useState(false);
  const { error } = useTypedSelector((state) => state.global);

  React.useEffect(() => {
    if (error) {
      setFieldValue('password', '');
    }
  }, [error]);

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
    setFocusToEnd();
  };

  const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const setFocusToEnd = () => {
    const input = inputRef?.current;
    if (input) {
      input.focus();

      var val = values.password;
      setFieldValue('password', '');
      setTimeout(() => {
        setFieldValue('password', val);
      }, 0);
    }
  };

  return (
    <PasswordInput
      {...props}
      type={showPassword ? 'text' : 'password'}
      ref={inputRef}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
